import { render } from "./PurchaseCompleteNatalChart.vue?vue&type=template&id=057912b2&scoped=true"
import script from "./PurchaseCompleteNatalChart.vue?vue&type=script&lang=js"
export * from "./PurchaseCompleteNatalChart.vue?vue&type=script&lang=js"

import "./PurchaseCompleteNatalChart.vue?vue&type=style&index=0&id=057912b2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057912b2"]])

export default __exports__